import React, { useState, useEffect, PropTypes } from "react"
import SearchResultInputBox from '../predictive-search/SearchResultBox';
import { Col, Container, Row, Form, Button } from 'react-bootstrap';
import { navigate } from "@reach/router"
import Select from 'react-select';
import $ from "jquery";
import _ from "lodash"


const styles = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#005480" : null,
      color: isFocused ? "#ffffff" : "#575757"
    };
  },
  control: styles => ({
    ...styles,
    backgroundColor: null,
    border: 0,
    paddingLeft: 0,
    outline: 0,
    boxShadow: 'none',
    color: '#4c505b',
    fontSize: '1rem',
    fontWeight: '300'
  }),
  valueContainer: (styles) => ({
    ...styles,
    fontSize: '1rem',
    paddingLeft: '10px',
    paddingRight: 0,
    lineHeight: '30px',
    fontWeight: '300',
    cursor: 'pointer'
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    //  color: "#ffffff",
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
    // color: '#ffffff',
    padding: 0,
    cursor: 'pointer'
  }),
  indicatorSeparator: () => null,
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: '#4c505b',
      marginLeft: 0
    }
  },
}

const SearchFilterCommercial = (props) => {
  const [filterOpen, setFilterOpen] = useState(false);
  const [areaVal, setAreaVal] = useState('');
  const [minpriceVal, setMinPriceVal] = useState('');
  const [maxpriceVal, setMaxPriceVal] = useState('');
  const [propertyval, setPropertyVal] = useState('');
  const [bedVal, setBedVal] = useState('');
  const [minPriceList, setMinPriceList] = useState([]);
  const [maxPriceList, setMaxPriceList] = useState([]);
  var area = "";
  const options = [
    { value: "", label: "Any" },
    { value: '1', label: '1 +' },
    { value: '2', label: '2 +' },
    { value: '3', label: '3 +' },
    { value: '4', label: '4 +' },
    { value: '5', label: '5 +' },
    { value: '6', label: '6 +' },
    { value: '7', label: '7 +' },
    { value: '8', label: '8 +' },
    { value: '9', label: '9 +' }
  ]
  const propertytypelist = [
    { value: "", label: "All" }, 
    { value: "office", label: "Offices" },
    { value: "warehouse", label: "Warehouses" },
    { value: "retail", label: "Retails" },
    { value: "shop", label: "Shops" },
    { value: "whole-building", label: "Whole Buildings" },
    { value: "business-center", label: "Business Centers" },
    { value: "labor-camp", label: "Labor Camps" },
    { value: "showroom", label: "Showrooms" },
    { value: "staff-accomodation", label: "Staff accomodations" },
    { value: "restaurant", label: "Restaurants" },
    { value: "farm", label: "Farms" },

    // { value: "semi-detached-house", label: "Semi Detached House" }
  ]
  // Min Price
  const [selectedMinPriceValue, setSelectedMinPriceValue] = useState(0);
  const priceminRangeLettings = [{ "value": "0", "label": "No Min" }, { "value": "20000", "label": "20,000 AED" }, { "value": "30000", "label": "30,000 AED" }, { "value": "40000", "label": "40,000 AED" }, { "value": "50000", "label": "50,000 AED" }, { "value": "60000", "label": "60,000 AED" }, { "value": "70000", "label": "70,000 AED" }, { "value": "80000", "label": "80,000 AED" }, { "value": "90000", "label": "90,000 AED" }, { "value": "100000", "label": "100,000 AED" }, { "value": "110000", "label": "110,000 AED" }, { "value": "120000", "label": "120,000 AED" }, { "value": "130000", "label": "130,000 AED" }, { "value": "140000", "label": "140,000 AED" }, { "value": "150000", "label": "150,000 AED" }, { "value": "160000", "label": "160,000 AED" }, { "value": "170000", "label": "170,000 AED" }, { "value": "180000", "label": "180,000 AED" }, { "value": "190000", "label": "190,000 AED" }, { "value": "200000", "label": "200,000 AED" }, { "value": "225000", "label": "225,000 AED" }, { "value": "250000", "label": "250,000 AED" }, { "value": "275000", "label": "275,000 AED" }, { "value": "300000", "label": "300,000 AED" }, { "value": "350000", "label": "350,000 AED" }, { "value": "400000", "label": "400,000 AED" }, { "value": "500000", "label": "500,000 AED" }, { "value": "750000", "label": "750,000 AED" }, { "value": "1000000", "label": "1,000,000 AED" }]
  const priceminRange = [{ "value": "0", "label": "No Min" }, { "value": "300000", "label": "300,000 AED" }, { "value": "400000", "label": "400,000 AED" }, { "value": "500000", "label": "500,000 AED" }, { "value": "600000", "label": "600,000 AED" }, { "value": "700000", "label": "700,000 AED" }, { "value": "800000", "label": "800,000 AED" }, { "value": "900000", "label": "900,000 AED" }, { "value": "1000000", "label": "1,000,000 AED" }, { "value": "1100000", "label": "1,100,000 AED" }, { "value": "1200000", "label": "1,200,000 AED" }, { "value": "1300000", "label": "1,300,000 AED" }, { "value": "1400000", "label": "1,400,000 AED" }, { "value": "1500000", "label": "1,500,000 AED" }, { "value": "1600000", "label": "1,650,000 AED" }, { "value": "1700000", "label": "1,700,000 AED" }, { "value": "1800000", "label": "1,800,000 AED" }, { "value": "1900000", "label": "1,900,000 AED" }, { "value": "2000000", "label": "2,000,000 AED" }, { "value": "2100000", "label": "2,100,000 AED" }, { "value": "2200000", "label": "2,200,000 AED" }, { "value": "2300000", "label": "2,300,000 AED" }, { "value": "2400000", "label": "2,400,000 AED" }, { "value": "2500000", "label": "2,500,000 AED" }, { "value": "2600000", "label": "2,600,000 AED" }, { "value": "2700000", "label": "2,700,000 AED" }, { "value": "2800000", "label": "2,800,000 AED" }, { "value": "2900000", "label": "2,900,000 AED" }, { "value": "3000000", "label": "3,000,000 AED" }, { "value": "3250000", "label": "3,250,000 AED" }, { "value": "3500000", "label": "3,500,000 AED" }, { "value": "3750000", "label": "3,750,000 AED" }, { "value": "4000000", "label": "4,000,000 AED" }, { "value": "4250000", "label": "4,250,000 AED" }, { "value": "4500000", "label": "4,500,000 AED" }, { "value": "5000000", "label": "5,000,000 AED" }, { "value": "6000000", "label": "6,000,000 AED" }, { "value": "7000000", "label": "7,000,000 AED" }, { "value": "8000000", "label": "8,000,000 AED" }, { "value": "9000000", "label": "9,000,000 AED" }, { "value": "10000000", "label": "10,000,000 AED" }, { "value": "25000000", "label": "25,000,000 AED" }, { "value": "50000000", "label": "50,000,000 AED" }]

  const [selectedMaxPriceValue, setSelectedMaxPriceValue] = useState(0);
  const pricemaxRangeLettings = [{ "value": "0", "label": "No Max" }, { "value": "20000", "label": "20,000 AED" }, { "value": "30000", "label": "30,000 AED" }, { "value": "40000", "label": "40,000 AED" }, { "value": "50000", "label": "50,000 AED" }, { "value": "60000", "label": "60,000 AED" }, { "value": "70000", "label": "70,000 AED" }, { "value": "80000", "label": "80,000 AED" }, { "value": "90000", "label": "90,000 AED" }, { "value": "100000", "label": "100,000 AED" }, { "value": "110000", "label": "110,000 AED" }, { "value": "120000", "label": "120,000 AED" }, { "value": "130000", "label": "130,000 AED" }, { "value": "140000", "label": "140,000 AED" }, { "value": "150000", "label": "150,000 AED" }, { "value": "160000", "label": "160,000 AED" }, { "value": "170000", "label": "170,000 AED" }, { "value": "180000", "label": "180,000 AED" }, { "value": "190000", "label": "190,000 AED" }, { "value": "200000", "label": "200,000 AED" }, { "value": "225000", "label": "225,000 AED" }, { "value": "250000", "label": "250,000 AED" }, { "value": "275000", "label": "275,000 AED" }, { "value": "300000", "label": "300,000 AED" }, { "value": "350000", "label": "350,000 AED" }, { "value": "400000", "label": "400,000 AED" }, { "value": "500000", "label": "500,000 AED" }, { "value": "750000", "label": "750,000 AED" }, { "value": "1000000", "label": "1,000,000 AED" }]
  const pricemaxRange = [{ "value": "0", "label": "No Max" }, { "value": "300000", "label": "300,000 AED" }, { "value": "400000", "label": "400,000 AED" }, { "value": "500000", "label": "500,000 AED" }, { "value": "600000", "label": "600,000 AED" }, { "value": "700000", "label": "700,000 AED" }, { "value": "800000", "label": "800,000 AED" }, { "value": "900000", "label": "900,000 AED" }, { "value": "1000000", "label": "1,000,000 AED" }, { "value": "1100000", "label": "1,100,000 AED" }, { "value": "1200000", "label": "1,200,000 AED" }, { "value": "1300000", "label": "1,300,000 AED" }, { "value": "1400000", "label": "1,400,000 AED" }, { "value": "1500000", "label": "1,500,000 AED" }, { "value": "1600000", "label": "1,650,000 AED" }, { "value": "1700000", "label": "1,700,000 AED" }, { "value": "1800000", "label": "1,800,000 AED" }, { "value": "1900000", "label": "1,900,000 AED" }, { "value": "2000000", "label": "2,000,000 AED" }, { "value": "2100000", "label": "2,100,000 AED" }, { "value": "2200000", "label": "2,200,000 AED" }, { "value": "2300000", "label": "2,300,000 AED" }, { "value": "2400000", "label": "2,400,000 AED" }, { "value": "2500000", "label": "2,500,000 AED" }, { "value": "2600000", "label": "2,600,000 AED" }, { "value": "2700000", "label": "2,700,000 AED" }, { "value": "2800000", "label": "2,800,000 AED" }, { "value": "2900000", "label": "2,900,000 AED" }, { "value": "3000000", "label": "3,000,000 AED" }, { "value": "3250000", "label": "3,250,000 AED" }, { "value": "3500000", "label": "3,500,000 AED" }, { "value": "3750000", "label": "3,750,000 AED" }, { "value": "4000000", "label": "4,000,000 AED" }, { "value": "4250000", "label": "4,250,000 AED" }, { "value": "4500000", "label": "4,500,000 AED" }, { "value": "5000000", "label": "5,000,000 AED" }, { "value": "6000000", "label": "6,000,000 AED" }, { "value": "7000000", "label": "7,000,000 AED" }, { "value": "8000000", "label": "8,000,000 AED" }, { "value": "9000000", "label": "9,000,000 AED" }, { "value": "10000000", "label": "10,000,000 AED" }, { "value": "25000000", "label": "25,000,000 AED" }, { "value": "50000000", "label": "50,000,000 AED" }]

  if (!_.isEmpty(props.searchState)) {

    if (!_.isEmpty(props.searchState?.query) && props.searchState?.query !== areaVal) {

      setAreaVal(props.searchState?.query)
    }
  }
  useEffect(() => {
    if (_.isEmpty(minPriceList)) {
      if (props.type === "lettings") {
        setMinPriceList(priceminRangeLettings);
        setMaxPriceList(pricemaxRangeLettings);
      } else {
        setMinPriceList(priceminRange)
        setMaxPriceList(pricemaxRange)
      }
    }


    // setAreaVal(_.upperFirst(pathUri[vi].replace("in-", "").replace(/-/g, " ")))

    const url = typeof window !== 'undefined' ? window.location.href : ''
    let pathUri = url.split("/")
    for (let vi = 1; vi <= pathUri.length; vi++) {
      // check for area
      if (typeof pathUri[vi] === "undefined") {
        continue
      }

      // Property type
      if (pathUri[vi].indexOf("type-") >= 0) {
        setPropertyVal(pathUri[vi].replace("type-", ""))
      }
      // Property type

      // Area
      if ((pathUri[vi].indexOf("in-") == 0) && (pathUri[vi].indexOf("in-london") == -1)) {
        setAreaVal(_.upperFirst(pathUri[vi].replace("in-", "").replace(/-/g, " ")))
      }
      // Area

      // Price
      if (
        pathUri[vi].indexOf("between-aed") >= 0 ||
        pathUri[vi].indexOf("above-aed") >= 0 ||
        pathUri[vi].indexOf("below-aed") >= 0
      ) {
        let priceFilt1 = pathUri[vi].split("above-aed")
        if (priceFilt1[1]) {
          setMinPriceVal(priceFilt1[1])
        }
        let priceFilt2 = pathUri[vi].split("below-aed")
        if (priceFilt2[1]) {
          setMaxPriceVal(priceFilt2[1])
        }
        let priceFilt3 = pathUri[vi].split("between-aed")
        if (priceFilt3[1]) {
          let priceFilt4 = priceFilt3[1].split("-and-aed")
          setMinPriceVal(priceFilt4[0])
          setMaxPriceVal(priceFilt4[1])
        }
      }
      // Price

      // Bedrooms
      if (pathUri[vi].indexOf("-and-more-") >= 0) {
        setBedVal(pathUri[vi].replace("-and-more-bedrooms", ""))
      }
      // Bedrooms 

    }
  }, []);

  const resetSearch = (e) => {
    var baseTypeUrl = props.locationname + "in-dubai";
    if (props.type == "lettings") {
      baseTypeUrl = props.locationname + "in-dubai";
    }
    navigate(baseTypeUrl)
  }
  const submitSearch = (e) => {
    e.preventDefault();
    var areaValue = $(".searchboxresults .searchVal").val().split(', ').join('-').replace(/ /g, "-").replace(/'/g, "").toLowerCase();
    if (_.isEmpty(areaValue)) {
      //  areaValue = $(".mobsearchboxresults .searchVal").val().split(', ').join('-').replace(/ /g, "-").replace(/'/g, "").toLowerCase();
    }
    var bedroomValue = bedVal ? bedVal : $(".bedroom-input input[type='hidden']").val();
    var buildingValue = propertyval ? propertyval : $(".building-dropdown input[type='hidden']").val();
    let priceUrl = ""
    if (maxpriceVal || minpriceVal) {
      if (minpriceVal && maxpriceVal && minpriceVal != "0" && maxpriceVal != "0") {
        priceUrl = "between-aed" + minpriceVal + "-and-aed" + maxpriceVal
      } else
        if ((minpriceVal == '' || minpriceVal == "0") && maxpriceVal && maxpriceVal != "0") {
          priceUrl = "below-aed" + maxpriceVal
        }
        else if (minpriceVal && (maxpriceVal == '' || maxpriceVal == "0") && minpriceVal != "0") {
          priceUrl = "above-aed" + minpriceVal
        }

    }
     
    var baseTypeUrl = (areaValue ? props.locationname + "in-" + areaValue + "/" : props.locationname);
    if (props.type == "lettings") {
      baseTypeUrl = (areaValue ?  props.locationname + "in-" + areaValue + "/" : props.locationname);
    }
    var searchFilterResults = (
      baseTypeUrl +
      (buildingValue ? "type-" + buildingValue + "/" : '') +
      (bedroomValue && bedroomValue != "0" ? bedroomValue + "-and-more-bedrooms/" : '') +
      (priceUrl ? priceUrl + "/" : '')

    );

    navigate(searchFilterResults)
  }
  // Min price
  const onChangeMinPrice = (e) => {
    setSelectedMinPriceValue(e.value);
    if (props.type === "lettings") {
      var maxPrice = pricemaxRangeLettings.filter(c => (c.value === "0" || parseInt(c.value) > parseInt(e.value)));
      setMaxPriceList(maxPrice);
    } else {
      var maxPrice = pricemaxRange.filter(c => (c.value === "0" || parseInt(c.value) > parseInt(e.value)));
      setMaxPriceList(maxPrice);
    }
  }
  // Min price

  // Max Price
  const onChangeMaxPrice = (e) => {
    setSelectedMaxPriceValue(e.value);
    if (props.type === "lettings") {
      var minPrice = priceminRangeLettings.filter(c => (c.value === "0" || parseInt(c.value) < parseInt(e.value)));
      setMinPriceList(minPrice);
    } else {
      var minPrice = priceminRange.filter(c => (c.value === "0" || parseInt(c.value) < parseInt(e.value)));
      setMinPriceList(minPrice);
    }
  }
  // Max Price

  // Filters
  const advancedFilterClose = (e) => {
    $(".dropdown-exp").toggleClass("active");
    setFilterOpen(false)
  }
  // Filters
  const clickHandle = (e) => {
    const li = e.target.closest('li');
    li.closest('ul').querySelectorAll('li').forEach(item => {
      if (item !== li) {
        item.classList.remove('active');
      }
    })
    e.target.closest('li').classList.toggle('active');
  }

  return (
    <React.Fragment>
      <Form onSubmit={(e) => { submitSearch(e) }}>
        <div className="filter-group">
          <div className="filter-search">
            <div className="filter-search-field filter-search-area searchboxresults">
              <SearchResultInputBox areaVal={areaVal} placeHolder={`Project name or Area`} />
            </div>
          </div>
          <div className="filter-select">
            <div className="filter-select-field building-field">
              <Select
                name="building"
                options={propertytypelist}
                value={propertytypelist.find(obj => obj.value === propertyval)}
                placeholder="Property Type"
                classNamePrefix={"select-opt"}
                onChange={e => setPropertyVal(e.value)}
                isSearchable={false}
                styles={styles}
              />
            </div>
            <div className="filter-select-field price-field salesprice-field">
              <ul className="filter-list">
                <li className="price-filter-dropdown">
                  <button type="button" onClick={clickHandle}>Price Range</button>
                  <div className="filter-dropdown">
                    <div className="select">
                      <Select
                        name="minprice"
                        options={minPriceList}
                        value={minPriceList.find(obj => obj.value === minpriceVal)}
                        isSearchable={false}
                        placeholder="Min Price"
                        classNamePrefix={"select-opt"}
                        onChange={e => { onChangeMinPrice(e); setMinPriceVal(e.value) }}
                        styles={styles}
                      />
                    </div>
                    <div className="select">
                      <Select
                        name="maxprice"
                        options={maxPriceList}
                        value={maxPriceList.find(obj => obj.value === maxpriceVal)}
                        isSearchable={false}
                        placeholder="Max Price"
                        classNamePrefix={"select-opt"}
                        onChange={e => { onChangeMaxPrice(e); setMaxPriceVal(e.value) }}
                        styles={styles}
                      />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div className="filter-select-field more-filter more-commercial">
              <button type="button" class="btn btn-select btn-more" onClick={() => { setFilterOpen(true) }}>More Filters <i class="filter-icon"></i></button>
            </div>
          </div>
          <div className="search-filter-button ">
            <button type="submit" class="btn btn-secondary search-button">Search</button>
          </div>
        </div>
      </Form>
      {filterOpen &&
        <section className={`filter-search-overlay ${filterOpen ? 'active-filter' : ''}`}>
          <div className="filter-close">

            <span className="close-menu" onClick={() => { advancedFilterClose() }}><i className="close-icon"></i></span>
          </div>

          <div className="filter-wrapper">
            <Container>
              <Row className="justify-content-center">
                <Col xl={6} lg={8} md={10}>
                  <div className="h3">Advanced Filters</div>
                  <div className="filter-select">
                    <div className="filter-select-field">
                      <Select
                        name="building"
                        options={propertytypelist}
                        value={propertytypelist.find(obj => obj.value === propertyval)}
                        placeholder="Property Type"
                        classNamePrefix={"select-opt"}
                        onChange={e => setPropertyVal(e.value)}
                        isSearchable={false}
                        styles={styles}
                      />
                    </div>
                    <div className="filter-select-field price-field">
                      <ul className="filter-list">
                        <li className="price-filter-dropdown">
                          <button type="button" onClick={clickHandle}>Price Range</button>
                          <div className="filter-dropdown">
                            <div className="select">
                              <Select
                                name="minprice"
                                options={minPriceList}
                                value={minPriceList.find(obj => obj.value === minpriceVal)}
                                isSearchable={false}
                                placeholder="Min Price"
                                classNamePrefix={"select-opt"}
                                onChange={e => { onChangeMinPrice(e); setMinPriceVal(e.value) }}
                                styles={styles}
                              />
                            </div>
                            <div className="select">
                              <Select
                                name="maxprice"
                                options={maxPriceList}
                                value={maxPriceList.find(obj => obj.value === maxpriceVal)}
                                isSearchable={false}
                                placeholder="Max Price"
                                classNamePrefix={"select-opt"}
                                onChange={e => { onChangeMaxPrice(e); setMaxPriceVal(e.value) }}
                                styles={styles}
                              />
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="refine-buttons">
                    <div className="d-flex justify-content-between">
                      <a  href="javascript:void(0)" className="btn btn-outline btn-outline--white"  onClick={(e) => {
                        resetSearch(e)
                        advancedFilterClose()  
                      }}><span>Clear Filters</span></a>
                      <a href="javascript:void(0)" onClick={(e) => {
                        submitSearch(e)
                        advancedFilterClose()  
                      }} className="btn btn-secondary"><span>Search</span></a>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </section>
      }
    </React.Fragment >
  );
};

export default SearchFilterCommercial;
